$mol_view_tree2_to_js_test_ex_array_spread_other_bar $mol_object
	sup /
		\v1
	arr /
		\v2
		^ sup
